export const companyFileSortingColumns = [
    'filename',
    'fileType',
    'date',
    'createdAt',
];
